import PropTypes from "prop-types";

import InvitationPage from "./auth_page/invitation_page";
import MagicLinkConfirmationPage from "./auth_page/magic_link_confirmation_page";
import PasswordRequestPage from "./auth_page/password_request_page";
import PasswordResetPage from "./auth_page/password_reset_page";
import SignInPage from "./auth_page/sign_in_page";

const AUTH_PAGE_COMPONENTS = {
  invitation: InvitationPage,
  magic_link_confirmation: MagicLinkConfirmationPage,
  password_request: PasswordRequestPage,
  password_reset: PasswordResetPage,
  sign_in: SignInPage,
};

const AuthPage = (props) => {
  const PageComponent = AUTH_PAGE_COMPONENTS[props.mode];

  return PageComponent ? <PageComponent {...props} /> : null;
};

AuthPage.propTypes = {
  mode: PropTypes.oneOf([
    "sign_in",
    "password_request",
    "magic_link_confirmation",
    "invitation",
    "password_reset",
  ]).isRequired,
};

export default AuthPage;
